import React from "react";
import { Arrow } from "./Arrow";

export function Footer({ profile, socials, version, onBackToTop }) {
  return (
    <footer className="footer" id="contact">
      <div className="page-width footer__inner">
        <div className="footer__top" data-reveal="fade">
          <span className="status-dot" />
          <p>Available for thoughtful products, useful systems, and focused collaborations.</p>
        </div>

        <div className="footer__contact">
          <small>Have a project in mind?</small>
          <a href={`mailto:${profile.email}`}>
            <span>{profile.email}</span>
            <Arrow />
          </a>
        </div>

        <div className="footer__bottom">
          <span>© 2026 {profile.name} / V{version}</span>
          <span>{profile.location}</span>
          <div>
            {socials.map((social) => (
              <a href={social.href} target="_blank" rel="noreferrer" key={social.label}>
                {social.label} <Arrow />
              </a>
            ))}
            <button type="button" onClick={onBackToTop}>Top <Arrow direction="up" /></button>
          </div>
        </div>
      </div>
    </footer>
  );
}
